import { Controller } from 'stimulus';

// Picking more equipment for a maintenance (the form's Equipment section, and
// Add equipment on a shared maintenance's page): search by ID, name,
// category, or location (MaintenancePlansController#equipment_search), the
// given category first, so an empty search suggests the same kind of
// equipment. Each pick is a hidden equipment_ids[] input with a remove
// button.
//
//   data-equipment-picker-url, -category (category id), -this (an equipment id to leave out)
export default class extends Controller {
  static targets = ['picked', 'query', 'results'];

  connect() {
    this.closeOnOutside = (event) => { if (!this.element.contains(event.target)) this.resultsTarget.classList.add('hidden'); };
    document.addEventListener('mousedown', this.closeOnOutside);
  }

  disconnect() {
    document.removeEventListener('mousedown', this.closeOnOutside);
  }

  search() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.fetchResults(), 200);
  }

  fetchResults() {
    const params = new URLSearchParams({ q: this.queryTarget.value, category_id: this.data.get('category') || '' });
    this.pickedIds().forEach((id) => params.append('exclude[]', id));
    if (this.data.get('this')) params.append('exclude[]', this.data.get('this'));
    fetch(`${this.data.get('url')}?${params}`, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : []))
      .then((items) => this.showResults(items))
      .catch(() => {});
  }

  showResults(items) {
    this.resultsTarget.innerHTML = '';
    if (items.length === 0) {
      const none = document.createElement('li');
      none.className = 'is-empty';
      none.textContent = 'No other in-service equipment matches.';
      this.resultsTarget.appendChild(none);
    }
    items.forEach((item) => {
      const row = document.createElement('li');
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.id = item.id;
      button.dataset.label = item.label;
      button.dataset.action = 'equipment-picker#add';
      button.textContent = `+ ${item.label}`;
      if (item.detail) {
        const detail = document.createElement('small');
        detail.textContent = item.detail;
        button.appendChild(detail);
      }
      row.appendChild(button);
      this.resultsTarget.appendChild(row);
    });
    this.resultsTarget.classList.remove('hidden');
  }

  add(event) {
    const { id, label } = event.currentTarget.dataset;
    if (this.pickedIds().includes(id)) return;

    const item = document.createElement('li');
    item.dataset.id = id;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'equipment_ids[]';
    input.value = id;
    const text = document.createElement('span');
    text.textContent = label;
    const remove = document.createElement('button');
    remove.type = 'button';
    remove.setAttribute('aria-label', `Remove ${label}`);
    remove.dataset.action = 'equipment-picker#remove';
    remove.textContent = '×';
    item.append(input, text, remove);
    this.pickedTarget.appendChild(item);
    event.currentTarget.closest('li').remove();
  }

  remove(event) {
    event.currentTarget.closest('li').remove();
  }

  pickedIds() {
    return Array.from(this.pickedTarget.querySelectorAll('li[data-id]')).map((li) => li.dataset.id);
  }
}
